<template>
  <!-- eslint-disable -->
<v-container fluid class="courier-config-container">
<v-slide-y-transition mode="out-in">
  <div>
    <v-btn color="pink" dark small absolute right fab class="add-courier-btn" @click="showDialog()">
      <v-icon>add</v-icon>
    </v-btn>

    <add-edit-courier />

    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-flex style="padding-bottom: 15px;">
          <v-text-field class="courier-search" slot="search" prepend-icon="search" :append-icon="search == '' || search.length === 0 ? '' : 'clear'" @click:append="() => (search = '')" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-flex>
        <v-btn class="clear-api-filter-btn" v-if="appliedApiFilter  != 0" text v-on:click="appliedApiFilter  = 0">Clear Api Filter</v-btn>
        <div class="text-xs-center">
          <v-progress-circular v-show="loading" style="align:center" indeterminate color="primary"></v-progress-circular>
        </div>
        <v-card>
          <v-list two-line v-if="!loading">
            <template v-for="(item) in filteredItems">
              <v-list-item :key="item.Id" @click="selectCourier(item)" class="courier-item">
                <v-list-item-avatar>
                  <v-chip class="api-type-1" v-if="item.ApiType == 1" color="teal" text-color="white" @click.stop="applyApiFilter(1)">
                    EC
                  </v-chip>
                  <v-chip class="api-type-2" v-else-if="item.ApiType == 2" color="orange" text-color="white" @click.stop="applyApiFilter(2)">
                    AX
                  </v-chip>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-html="item.Name"></v-list-item-title>
                  <v-list-item-subtitle>{{item.Address.City}}, {{item.Address.State}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>{{item.MSAAssignment}}</v-list-item-action-text>
                  <v-icon v-if="item.IsEnabled">check_box</v-icon>
                  <v-icon v-else>check_box_outline_blank</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
  </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>

<script>
import AddEditCourier from "@/components/couriers/config/AddEditCourier";
import courierConfigModule, {
  COURIER_CONFIG_NAMESPACE
} from "./store/courierConfigStore";
import { mapGetters } from "vuex";
import { EVENTS } from "./config";

export default {
  name: "CourierConfig",
  components: { "add-edit-courier": AddEditCourier },
  data() {
    return {
      appliedApiFilter: 0,
      search: ""
    };
  },
  computed: {
    ...mapGetters(COURIER_CONFIG_NAMESPACE, [
      "couriers",
      "axis",
      "eCourier",
      "loading"
    ]),
    filteredItems() {
      var couriers = [];
      if (this.appliedApiFilter === 1) {
        couriers = this.eCourier;
      } else if (this.appliedApiFilter === 2) {
        couriers = this.axis;
      } else couriers = this.couriers;
      if (this.search)
        return couriers.filter(x =>
          x.Name.toLowerCase().includes(this.search.toLowerCase())
        );
      return couriers;
    }
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(COURIER_CONFIG_NAMESPACE, courierConfigModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.COURIER_ADMIN]).then(
      res => {
        if (res) {
          this.loadCouriers();
        } else this.$goHome();
      }
    );
  },
  methods: {
    applyApiFilter(apiType) {
      this.appliedApiFilter = apiType;
    },
    showDialog() {
      return this.$emit(EVENTS.OPEN_DETAIL_DIALOG, { Address: {} });
    },
    selectCourier(item) {
      if (item) {
        this.$emit(EVENTS.OPEN_DETAIL_DIALOG, item);
      }
      return this.$store.dispatch(
        `${COURIER_CONFIG_NAMESPACE}/setSelected`,
        item
      );
    },
    loadCouriers() {
      return this.$store.dispatch(`${COURIER_CONFIG_NAMESPACE}/loadCouriers`);
    }
  }
};
</script>
